import { useReducer } from 'react';

// API

import { api, replaceParamsInStr } from '../common-utils-services/axiosUtil';
import endpoints from '../../constants/configs/endpoints';

// endpoints

const SEARCH_RESULTS_FOR_DEV_ENV = '/mocks/archive-hh/archive-search-results.json';
const NO_SEARCH_RESULTS_FOR_DEV_ENV = '/mocks/archive-hh/archive-no-search-results.json';
// const SEARCH_RESULTS_ERROR_FOR_DEV_ENV = '/mocks/archive-hh/archive-search-results-error.json';
const ARCHIVE_SUCCESS_FOR_DEV_ENV = '/mocks/archive-hh/archive-success.json';
const ARCHIVE_ERROR_FOR_DEV_ENV = '/mocks/archive-hh/archive-error.json';

const actions = {
    ARCHIVE_HH: 'ARCHIVE_HH',
    ARCHIVE_HH_ERROR: 'ARCHIVE_HH_ERROR',
    NO_SEARCH_RESULTS_BY_HH_ID: 'NO_SEARCH_RESULTS_BY_HH_ID',
    SEARCH_BY_HH_ID: 'SEARCH_BY_HH_ID'
};

interface Location {
    address1: string;
    address2: string | null;
    city: string;
    state: string;
    countyCode: string;
    zip: number;
}

export interface ArchiveSearchDetails {
    encHouseholdId: string;
    householdId: string,
    username: string,
    location: Location | undefined,
    applicationYears: string[],
    enrollmentYears: string[],
    isInboxmsgPresent: boolean,
    AgentDesignated: string | null,
    isArchived: boolean,
    canUnarchived: boolean
}
export interface ArchiveHouseholdSearchResponse {
    errorMessage?: string | null;
    results: ArchiveSearchDetails | null;
};

export interface ArchiveHouseholdResponse {
    errorMessage: string | null;
}

type Action =
  | { type: 'NO_SEARCH_RESULTS_BY_HH_ID', payload: ArchiveHouseholdSearchResponse | null }
  | { type: 'SEARCH_BY_HH_ID', payload: ArchiveSearchDetails }
  | { type: 'ARCHIVE_HH_ERROR', payload: ArchiveHouseholdResponse }
  | { type: 'ARCHIVE_HH', payload: ArchiveHouseholdResponse }

function reducer(state, action: Action) {
    switch (action.type) {
        case actions.NO_SEARCH_RESULTS_BY_HH_ID:
            return {
                ...state,
                data: [],
                isError: false
            }
        case actions.SEARCH_BY_HH_ID:
            return {
                ...state,
                data: [action.payload],
                isError: false
            };
        case actions.ARCHIVE_HH_ERROR:
            return {
                ...state,
                data: [],
                isError: true,
                errorMessage: action.payload
            }
        case actions.ARCHIVE_HH:
          return {
              ...state,
              data: [],
              isError: !!action.payload,
              errorMessage: action.payload
          }
        default:
            return state;
    }
}

const initialState: ArchiveHouseholdSearchResponse | undefined = undefined;

export default () => {
    const [data, dispatch]  = useReducer(reducer, initialState);

    const searchByHouseholdId = async (hhId: string) => {
        try {
            const url = global.__ENV__.PRODUCTION ? endpoints.ARCHIVE_HH_SEARCH : SEARCH_RESULTS_FOR_DEV_ENV;
            const endpoint = replaceParamsInStr(url, { hhid: hhId });
            const res = await api.get<ArchiveHouseholdSearchResponse>(endpoint);
            if (res?.data?.errorMessage) {
                dispatch({ type: 'ARCHIVE_HH_ERROR', payload: { errorMessage: "There was an error in searching for household ID" }});
            } else if (res?.data?.results?.username) {
                dispatch({ type: 'SEARCH_BY_HH_ID', payload: res?.data?.results });
            } else {
                dispatch({ type: 'NO_SEARCH_RESULTS_BY_HH_ID', payload: null });
            }
        } catch (e) {
            console.log(`In useArchiveHousehold: searchByHouseholdId(): Request to (${endpoints.ARCHIVE_HH_SEARCH}) failed with error = `, e);
            dispatch({ type: 'ARCHIVE_HH_ERROR', payload: { errorMessage: e }});
        }
    };

    const archiveHousehold = async (encHouseholdId: string): Promise<ArchiveHouseholdResponse> => {
        const url = global.__ENV__.PRODUCTION ? endpoints.ARCHIVE_HH_ARCHIVE : ARCHIVE_SUCCESS_FOR_DEV_ENV;
        let formData = new FormData();
        formData.append("encHouseholdId", encHouseholdId);
        const res = global.__ENV__.PRODUCTION ? await api.post<ArchiveHouseholdResponse>(url, formData): await api.get<ArchiveHouseholdResponse>(url);
        return Promise.resolve({
            errorMessage: res.data.errorMessage
        });
    };

    const unArchiveHousehold = async (encHouseholdId: string): Promise<ArchiveHouseholdResponse> => {
        const url = global.__ENV__.PRODUCTION ? endpoints.ARCHIVE_HH_UNARCHIVE : ARCHIVE_ERROR_FOR_DEV_ENV;
        let formData = new FormData();
        formData.append("encHouseholdId", encHouseholdId);
        const res = global.__ENV__.PRODUCTION ? await api.post<ArchiveHouseholdResponse>(url, formData): await api.get<ArchiveHouseholdResponse>(url);
        return Promise.resolve({
            errorMessage: res.data.errorMessage
        });
    };

    return {
        ...data,
        searchByHouseholdId: (hhId: string) => {
            searchByHouseholdId(hhId);
        },
        archiveHousehold: (encHouseholdId: string): Promise<ArchiveHouseholdResponse> => {
            return archiveHousehold(encHouseholdId);
        },
        unArchiveHousehold: (encHouseholdId: string): Promise<ArchiveHouseholdResponse> => {
            return unArchiveHousehold(encHouseholdId);
        }
    };
};